// OrderPaymentModal.jsx (your existing component is good)
import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { API } from "aws-amplify";
import { Context } from "../../../../Context";

const OrderPaymentModal = ({ 
  selectedTable, 
  institutionData, 
  onClose, 
  selectedOrderId, 
  fetchTableData,
  fetchPendingOrders,customerDetails
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const paymentMethods = ["QR", "Cash", "Card"];
  const { setLoader } = useContext(Context);
  const tableIdStr = String(selectedTable.id);

  const handlePayment = async () => {
    setLoader(true);
    if (!selectedPaymentMethod) {
      toast.error("Please select a payment method.");
      setLoader(false);
      return;
    }

    try {
      // Call the API to settle the specific order
       let billLink = '';
            
              billLink = `https://bhukkadrestrocafe.awsaiapp.com/receipt?orderIds=${selectedOrderId}`;
            
            
            // Only send message if phone number exists and we have a bill link
            const customerPhone = customerDetails[selectedTable?.id]?.phone;
            if (customerPhone && billLink &&  institutionData.institution === "bhuk2323") {
              try {
                await API.post(
                  'main', 
                  `/admin/send-message/${institutionData.institution}`,
                  {
                    body: {
                      customerName: customerDetails[selectedTable?.id]?.name || '',
                      customerPhone: `+91${customerPhone}`,
                      billLink: billLink,
                      companyName: institutionData.companyName
                    }
                  }
                );
              } catch (msgError) {
                console.error("Error sending message:", msgError);
                  setLoader(false);
              }
            }
      await API.post(
        "main",
        `/admin/settle-bill-order/${institutionData.institution}/${tableIdStr}/${selectedOrderId}`,
        {
          body: {
            paymentStatus: true,
            paymentMode: "offline",
            paymentMethod: selectedPaymentMethod
          },
        }
      );
      
      onClose();
      setLoader(false);
      
      // Refresh the table data and pending orders
      await fetchTableData(tableIdStr);
      await fetchPendingOrders();
      
      toast.success(`Order #${selectedOrderId} payment successful!`);
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error("Failed to process payment.");
      setLoader(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-96">
        <h2 className="text-2xl font-bold text-center mb-4 text-gray-800">Settle Order</h2>
        <p className="text-gray-600 mb-2">Table: <strong>{selectedTable.id}</strong></p>
        <p className="text-gray-600 mb-4">Order ID: <strong>{selectedOrderId}</strong></p>

        <h3 className="font-semibold mb-3 text-gray-700">Choose Payment Method:</h3>
        <div className="grid grid-cols-3 gap-3">
          {paymentMethods.map((method) => (
            <button
              key={method}
              className={`p-3 rounded-md font-semibold border ${
                selectedPaymentMethod === method
                  ? "bg-green-500 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
              onClick={() => setSelectedPaymentMethod(method)}
            >
              {method}
            </button>
          ))}
        </div>

        <div className="flex justify-between mt-6">
          <button
            onClick={onClose}
            className="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={handlePayment}
            className={`px-4 py-2 rounded-md text-white ${
              selectedPaymentMethod ? "bg-green-700 hover:bg-green-800" : "bg-gray-400"
            }`}
            disabled={!selectedPaymentMethod}
          >
            Confirm Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderPaymentModal;